<template>
  <div class="abooutContent">
    <div class="backimg">
      <img
        :src="img"
        alt=""
        style=" width: 100%;height: 100%;vertical-align:middle;"
      />
      <div class="betweencenter">
        <div class="real">
          <div class="tis bigcolor">{{$t('company.title')}}</div>
          <div class="tixt" style="font-size:30px;color:#ccc;">
            {{$t('company.text')}}
          </div>
        </div>
      </div>
    </div>
    <div style="margin:60px 0;">
      <h1>{{$t('company.header')}}</h1>
      <div class="botcolor">Company profile</div>
    </div>
    <div class="solution">
      <!-- 关于我们 -->
      <div class="buisnessrequire">
        <div class="buisnesstext">
          <div class="headers">
            <span class="pic"></span>
            <span class="titles">{{$t('company.about') }}</span>
          </div>
          <ul>
            <li
              v-for="(item, index) in $t('company.aboutList')"
              :key="index"
              class="colors hes"
              :title="item.name"
            >
              • {{ item.name | aboutellipsis}}
            </li>
          </ul>
        </div>
        <div class="buisness">
          <img src="../../assets/img/us/maps.png" alt="" />
        </div>
      </div>
       <div style="font-size:12px;color:#1d5a33;text-align:right;">{{$t('company.map')}}</div>
      <!--  资质认证 -->
      <div class="headers">
        <span class="pic"></span>
        <span class="titles">{{ $t('company.identity') }}</span>
      </div>
      <div class="contents">
        <div class="navs">
          <div v-for="(item, it) in $t('company.textlist')" :key="it" class="list">
            <div class="jiesh">
              <img :src="item.img" alt="" />
            </div>
            <div class="textli">
              <p class="tixt" :title="item.name">{{ item.name |indenllipsis}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 合作伙伴 -->
    <div class="partnerback">
      <div class="solution">
        <div class="headers">
          <span class="pic"></span>
          <span class="titles">{{ $t('company.advantage') }}</span>
        </div>
        <div class="parnter">
          <div>
            <img
              src="../../assets/img/main/parner1.png"
              style="transition: all 0.5s;"
              alt=""
            />
            <img
              src="../../assets/img/us/partner2.png"
              style="transition: all 0.5s;margin-top:20px;"
              alt=""
              v-show="btnstatus"
            />
          </div>
          <el-button
            type="success"
            class="btnmars"
            v-show="!btnstatus"
            @click="btntap"
            >{{$t('company.look')}}</el-button
          >
          <el-button
            type="success"
            class="btnmars"
            v-show="btnstatus"
            @click="btntaps"
            >{{$t('company.retract')}}</el-button
          >
        </div>
      </div>
    </div>
    <!-- 联系我们 -->
    <div class="solution">
      <div class="headers" style="margin-top:60px;">
        <span class="pic"></span>
        <span class="titles">{{ $t('company.serve') }}</span>
      </div>
      <div class="services">
        <div class="contenttel">
          <div class="navs">
            <div v-for="(item, itm) in $t('company.connect')" :key="itm" class="list">
              <div class="jiesh">
                <img v-if="item.img" :src="item.img" alt="" />
                <img v-if="item.imgs" :src="item.imgs" alt="" />
                <div class="pos" v-show="item.name">
                  <p class="tixts">{{ item.title }}</p>
                  <p class="tixt">{{ item.name }}</p>
                </div>
                <div class="phone" v-show="item.phone">
                  <div>
                    <img :src="item.call" alt="" />
                  </div>
                  <p>{{ item.phone }} {{ item.tel }}</p>
                  <p>{{ item.componey }}</p>
                  <p>{{ item.add }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      img: require("../../assets/img/us/banner.png"),
      textlist: [
        {
          name: "ISO 9001 质量管理体系证书",
          img: require("../../assets/img/us/identify01.png")
        },
        {
          name: "计算机软件著作权登记证书",
          img: require("../../assets/img/us/identify02.png")
        },
        {
          name: "ICP增值电信业务许可证",
          img: require("../../assets/img/us/identify03.png")
        },
        {
          name: "实用新型专利证书",
          img: require("../../assets/img/us/identify04.png")
        }
      ],
      identify: [
        {
          name: "中关村高新技术企业",
          img: require("../../assets/img/us/identify05.jpg")
        },
        {
          name: "国家高新技术认定企业",
          img: require("../../assets/img/us/identify06.png")
        }
      ],
      connect: [
        {
          name: "北京总部",
          title: "Beijing headquarters",
          img: require("../../assets/img/us/01.png")
        },
        {
          name: "深圳办事处",
          title: "Shenzhen office",
          img: require("../../assets/img/us/02.png")
        },
        {
          name: "上海办事处",
          title: "Shanghai Office",
          img: require("../../assets/img/us/03.png")
        },
        {
          imgs: require("../../assets/img/us/04.png"),
          call: require("../../assets/img/us/CALL us.png"),
          phone: "7*24*365小时保障电话：",
          tel: "852-5123-4372",
          add: "Add：北京市朝阳区酒仙桥东路9号院A5楼4层"
        }
      ],
      title: "关于我们",
      identity: "资质认证",
      advantage: "合作伙伴",
      serve: "联系我们",
      aboutList: [
        {
          name: "成立于2012年5月，致力于打造国内高端的电信增值业务服务商"
        },
        {
          name:
            "经营业务包括：国内互联网接入、国内企业VPN、DC-DC直连、DC-Cloud直连、SD-WAN连接、企业网络代维等服务"
        },
        {
          name: "在中国并提供基于SD-WAN的混合式云VPN的接入服务"
        },
        {
          name: "北京、 广州 、上海提供三地NOC运维团队，7*24*365全方位运维服务"
        },
        {
          name: "国内超过30家渠道同行业合作模式，打造全方位开放式生态合作模式"
        },
        {
          name: "具备国内固网传输和增值业务运营牌照"
        }
      ],
      btntext: "查看更多",
      btnstatus: false,
      buttonstatus: false
    };
  },
  methods: {
    btntap() {
      this.btnstatus = true;
    },
    btntaps() {
      this.btnstatus = false;
    },
    btnclick() {
      this.buttonstatus = true;
    },
    btnclicks() {
      this.buttonstatus = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.abooutContent {
  width: 100%;
  margin: 0 auto;
  // 标题
  .backimg {
    position: relative;
    overflow: hidden;
    .betweencenter {
      width: 1200px;
      margin: 0 auto;
      .real {
        position: absolute;
        top: 150px;
        z-index: 1000;
        text-align: left;
        .tis {
          width: 420px;
          letter-spacing: 0px;
          line-height: 16px;
          font-size: 48px;
        }
        .tixt {
          width: 460px;
          margin-top: 36px;
          line-height: 30px;
          font-size: 14px;
          letter-spacing: 1px;
        }
      }
    }
  }
  // 头部简介
  .headers {
    text-align: left;
    margin-bottom: 60px;
    height: 40px;
    line-height: 40px;
    .pic {
      height: 25px;
      border-right: 7px solid #1d5a33;
      display: inline-block;
      margin-right: 14px;
      vertical-align: middle;
    }
    .titles {
      font-size: 30px;
      vertical-align: middle;
      color: #333;
      font-weight: 700;
    }
    .matter {
      text-align: left;
      padding: 0 40px;
      line-height: 2;
    }
  }
  .solution {
    width: 1200px;
    margin: 0 auto;
    // 关于我们
    .buisnessrequire {
      display: flex;
      justify-content: space-between;
      .buisnesstext {
        text-align: left;
        width: 560px;
        .hes {
          line-height: 32px;
        }
      }
      .buisness {
        img {
          width: 100%;
          height: 100%;
          vertical-align: middle;
        }
      }
    }
    // 资质认证
    .contents {
      .navs {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-bottom: 80px;
        .list {
          .jiesh {
            display: flex;
            justify-content: center;
            img {
              width: 200px;
              height: 260px;
              vertical-align: middle;
            }
          }
        }
        .textli {
          margin-top: 40px;
          .tixt {
            font-size: 16px;
            color: #666;
            margin-top: 10px;
            margin-bottom: 10px;
          }
        }
      }
      .nav {
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
         margin-bottom: 60px;
        .list {
          .jiesh {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 364px;
            height: 257px;
            img {
              vertical-align: middle;
            }
          }
        }
        .textli {
          margin-top: 40px;
          .tixt {
            font-size: 16px;
            color: #666;
            margin-top: 10px;
            margin-bottom: 10px;
          }
        }
      }
    }
    // 服务
    .services {
      display: flex;
      justify-content: left;
      margin-bottom: 35px;
      width: 1200px;
      .contenttel {
        .navs {
          display: flex;
          justify-content: space-around;
          flex-wrap: wrap;
          .list {
            width: 590px;
            margin-bottom: 60px;
            div {
              margin: auto;
            }
          }
          .jiesh {
            box-sizing: border-box;
            position: relative;
            .phone {
              width: 440px;
              position: absolute;
              left: 30px;
              bottom: 0;
              text-align: left;
              img {
                width: 122px;
                height: 66px;
                vertical-align: middle;
                margin-bottom: 10px;
              }
              p {
                margin-bottom: 10px;
                font-size: 16px;
                color: #666;
              }
            }
            .pos {
              width: 300px;
              height: 68px;
              display: flex;
              flex-direction: column;
              position: absolute;
              top: 50%;
              left: 50%;
              margin-left: -150px;
              margin-top: -34px;
              .tixts {
                color: #fff;
                font-size: 24px;
              }
              .tixt {
                color: #fff;
                font-size: 18px;
                margin-top: 12px;
              }
            }
            img {
              width: 100%;
              height: 100%;
              vertical-align: middle;
            }
          }
        }
      }
    }
  }
  .partnerback {
    width: 100%;
    margin: 0 auto;
    background: #f4f4f4;
    padding: 64px 0;
    margin-top: 100px;
    .parnter {
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
        vertical-align: middle;
      }
    }
  }
  .btnmar {
    margin-top: 20px;
  }
  .btnmars {
    margin-top: 80px;
  }
}
</style>
